import { jsxs as l, jsx as r } from "react/jsx-runtime";
import m from "clsx";
import { forwardRef as o } from "react";
import e from "./Switch.module.css.js";
const t = o(({ size: s = "small", error: a, ...i }, c) => /* @__PURE__ */ l("div", { className: m(e.container, { [e.large]: s === "large", [e.error]: a }), children: [
  /* @__PURE__ */ r("div", { className: e.circle }),
  /* @__PURE__ */ r("div", { className: e.line }),
  /* @__PURE__ */ r("div", { className: e.handle }),
  /* @__PURE__ */ r("input", { className: e.input, type: "checkbox", role: "switch", ref: c, ...i })
] }));
t.displayName = "Switch";
export {
  t as Switch
};
//# sourceMappingURL=Switch.js.map
